import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useHistory } from "react-router-dom";
import "./LogoWithWarning.css";

const LogoWithWarning = ({
  logoUrl = "https://res.cloudinary.com/cqn/image/upload/v1740519381/white_acetechies_logo_vsdhp5.png",
  logoAlt = "Logo",
  brandName = ["AceTechies", "Academy"],
  showWarningModal = true,
  redirectTo = "/",
  warningTitle = "Are you sure you want to leave?",
  warningMessage = "Your progress will not be saved if you leave this page.",
  onLogoClick = null,
  logoWidth = "40px",
  logoHeight = "50px",
  position = { top: "10px", left: "10px" },
}) => {
  const [showWarning, setShowWarning] = useState(false);
  const history = useHistory();

  const handleLogoClick = () => {
    if (onLogoClick) {
      onLogoClick();
      return;
    }

    if (showWarningModal) {
      setShowWarning(true);
    } else {
      history.push(redirectTo);
    }
  };

  const handleConfirmLeave = () => {
    setShowWarning(false);
    history.push(redirectTo);
  };

  const handleCancelLeave = () => {
    setShowWarning(false);
  };

  return (
    <>
      <div
        className="logoWithWarning__container"
        style={{
          top: position.top,
          left: position.left,
        }}
        onClick={handleLogoClick}
      >
        <img
          src={logoUrl}
          alt={logoAlt}
          className="logoWithWarning__image"
          style={{ width: logoWidth, height: logoHeight }}
        />
        <div className="logoWithWarning__nameContainer">
          {Array.isArray(brandName) ? (
            brandName.map((name, index) => (
              <p key={index} className="logoWithWarning__nameText">
                {name}
              </p>
            ))
          ) : (
            <p className="logoWithWarning__nameText">{brandName}</p>
          )}
        </div>
      </div>

      <AnimatePresence>
        {showWarning && (
          <motion.div
            className="logoWithWarning__modalBackdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleCancelLeave}
          >
            <motion.div
              className="logoWithWarning__warningModal"
              initial={{ opacity: 0, scale: 0.8, y: -50 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.8, y: -50 }}
              transition={{ type: "spring", stiffness: 300, damping: 25 }}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className="logoWithWarning__warningTitle">{warningTitle}</h3>
              <p className="logoWithWarning__warningText">{warningMessage}</p>
              <div className="logoWithWarning__warningButtons">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="logoWithWarning__cancelButton"
                  onClick={handleCancelLeave}
                >
                  Cancel
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="logoWithWarning__confirmButton"
                  onClick={handleConfirmLeave}
                >
                  OK
                </motion.button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default LogoWithWarning;
